export default __webpack_public_path__ + "static/media/gallery_00.6a3586a4.jpg";